<template>
  <div style="height: 100vh; padding: 10px 10px 10px 20px">
    <iframe
      v-bind:src="`https://banhang.atosa.asia/authenticate/handle?redirect=%2Fpayment%2Ftransfer%3Fchannel%3Dshopee_marketing,shopee_marketing_survey,shopee_analysis,shopee_analysis_spoiler%26package_id%3D%26quantity%3D3%26voucher_code%3D&token=${this.$store.state.userInfo.token}`"
      title="Internet Banking" style="width: 100%; height: 100%; border: none"
      frameBorder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: 'page_ipayment',

  data() {
    return {
      package_id: '',
      quantity: 1,
      voucher_code: ''
    }
  },

  beforeMount() {
    this.package_id = this.$route.query.package_id
    this.quantity = this.$route.query.quantity
    this.voucher_code = this.$route.query.voucher_code
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/sign/ipayment.vue